module.exports = __webpack_public_path__ + "static/img/03-shuiwuguanliyun.27d2c8f3.png";